import { Base } from "./base";
import { UntypedFormGroup } from "@angular/forms";

export interface IngredientsFilters {
  search?: string;
}

export interface IngredientDTO {
  id?: number;
  name?: string;
  description?: string;
  type?: string;
  minus_price?: number;
  addition_price?: number;
}
export class Ingredient extends Base {
  name: string;
  description: string;
  type: string;
  additionPrice: number;
  minusPrice: number;

  constructor(source: IngredientDTO) {
    super(source);
    if (source) {
      this.name = source.name;
      this.description = source.description;
      this.type = source.type;
      this.additionPrice = source.addition_price;
      this.minusPrice = source.minus_price;
    }
  }

  public toDTO(): IngredientDTO {
    let dto: IngredientDTO = {
      id: this.id,
      name: this.name,
      description: this.description,
      type: this.type,
      addition_price: this.additionPrice,
      minus_price: this.minusPrice
    };
    return dto;
  }

  static fromFormGroup(formGroup: UntypedFormGroup, original?: Ingredient): Ingredient {
    const formModel = formGroup.value;
    let ingredient: Ingredient = new Ingredient(null);
    ingredient.name = formModel.name;
    ingredient.additionPrice = formModel.additionPrice;
    ingredient.minusPrice = formModel.minusPrice;
    ingredient.type = formModel.type;
    ingredient.description = formModel.description;
    
    if(original){
      ingredient.id = original.id;
    }
    return ingredient;
  }

}
